import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import config from 'react-global-configuration';
import jwtDecode from 'jwt-decode';

import * as UsersActions from '../../modules/users/UsersState';
import * as OrganizationsActions from '../../modules/organizations/OrganizationsState';

const UserAuthorizationNamespace = 'http://www.freightverify.com/user_authorization';

export const Privileges = {
    CHANGE_ACTIVE_ORGANIZATION: 'CHANGE_ACTIVE_ORGANIZATION',
    MANAGE_CARRIER_LOCATIONS: 'MANAGE_CARRIER_LOCATIONS',
    MANAGE_LOCATIONS: 'MANAGE_LOCATIONS',
    MANAGE_ORGANIZATIONS: 'MANAGE_ORGANIZATIONS',
    MANAGE_SHIPMENTS: 'MANAGE_SHIPMENTS',
    MANAGE_USERS: 'MANAGE_USERS',
    VIEW_LOCATIONS: 'VIEW_LOCATIONS',
    VIEW_SHIPMENTS: 'VIEW_SHIPMENTS'	
}

export const Roles = {
    CARRIER_SYSTEM: 'CARRIER_SYSTEM',
    FREIGHTVERIFY_ADMIN: 'FREIGHTVERIFY_ADMIN',
    ORGANIZATION_ADMIN: 'ORGANIZATION_ADMIN',
    ORGANIZATION_USER: 'ORGANIZATION_USER',
    THIRD_PARTY_SYSTEM: 'THIRD_PARTY_SYSTEM'
}

function mapStateToProps(state) {
    return {
        auth: state.users.auth,
        currentUser: state.users.currentUser,
        organizations: state.organizations.data ? state.organizations.data.response : state.organizations.data
    };
}

function allowedRolesContainsName(allowedPrivileges, names) {
    if (0 === names.length) {
        return false;
    }

    return names.some(r => allowedPrivileges.includes(r));
}

export function hasPrivileges(names) {
    if (sessionStorage.getItem('access_token')) {
        const userClaims = jwtDecode(sessionStorage.getItem('access_token'))
        if (names && userClaims) {
            const userAuthorization = userClaims[UserAuthorizationNamespace];
            return names.some(r=> userAuthorization.privileges.includes(r));
        }
    }
    
    return false;
}

export function hasRole(name, roles) {
    if (sessionStorage.getItem('access_token')) {
        const userClaims = jwtDecode(sessionStorage.getItem('access_token'))
        if (name && roles && userClaims) {
            const userAuthorization = userClaims[UserAuthorizationNamespace];
            const role = _.find(roles, function(r) {return r.name === name});

            if (role && role.hasOwnProperty('users')) {
                return _.includes(role.users, userAuthorization.user_id)
            }
        }
    }

    return false;
}

/**
 * HOC that Handles whether or not the user is allowed to see the page.
 */
export function Authorization(WrappedComponent, allowedPrivileges) {
    
    class WithAuthorization extends Component {
        
        componentWillMount() {
            const { auth, currentUser, dispatch } = this.props;
            const enableAuth = config.get('enable_authentication');

            if (enableAuth && !auth.isAuthenticated()) {
                // if not authenticated, show login view
                dispatch(UsersActions.setCurrentUser(null));        
                auth.logout();                                 
                auth.login();
                return null;                    
            }
            else if (!currentUser) {
                const userClaims = auth.getDecodedToken();
                dispatch(UsersActions.setCurrentUser(userClaims));

                if (userClaims && userClaims.hasOwnProperty(UserAuthorizationNamespace)) {      
                    const organizationId = sessionStorage.getItem('currentOrganization') 
                    ? sessionStorage.getItem('currentOrganization') : userClaims[UserAuthorizationNamespace].organization_id;              
                    dispatch(OrganizationsActions.setCurrentOrganization(organizationId));
                }
            }
        }

        render() {
            const { currentUser } = this.props;

            if (currentUser) {                    
                const userAuthorization = currentUser[UserAuthorizationNamespace];
                if (allowedRolesContainsName(allowedPrivileges, userAuthorization.privileges)) {
                    return <WrappedComponent {...this.props} />;
                }
                else {
                    //TODO: create error page for no access
                    window.location.href = '/accessForbiddenError';
                    return null;
                }
            }

            return null;
        }
    };

    return connect(
        mapStateToProps
    )(WithAuthorization);
};


// WEBPACK FOOTER //
// ./src/modules/auth/authorization.js